import React from 'react';

import { InputRadio } from '../InputRadio';
import { InputText } from '../InputText';
import Tooltip from '../Tooltip';
import InfoIcon from '../InfoIcon';

// Translations
import { TranslationKey } from '../../translations';
import { useTranslation } from '../../translations/useTranslation';

interface Props {
  name: string;
  label: string;
  value: string | null;
  type: 'radio' | 'checkbox' | 'text';
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  radioButtonValue?: string | null;
  radioButtonTooltipTranslationKey?: TranslationKey;
}

export const Answer: React.FC<Props> = ({
  name,
  label,
  value,
  type,
  radioButtonValue,
  radioButtonTooltipTranslationKey,
  onChange,
}) => {
  const { t } = useTranslation();
  switch (type) {
    case 'radio': {
      return (
        <>
          {radioButtonValue ? (
            <div className='membership-app__choice-wrapper'>
              <InputRadio
                label={label}
                name={name}
                value={radioButtonValue || ''}
                checked={value === radioButtonValue}
                onChange={onChange}
              />
              {radioButtonTooltipTranslationKey && (
                <Tooltip
                  content={<p>{t(radioButtonTooltipTranslationKey)}</p>}
                  trigger={
                    <span className="membership-app__choice-tooltip">
                      <InfoIcon size="sm" />
                    </span>
                  }
                />
              )}
            </div>
          ) : null}
        </>
      );
    }

    case 'text': {
      return <InputText name={name} value={value || ''} onChange={onChange} />;
    }

    default:
      return null;
  }
};
